'use client';

import { c as _c } from "react/compiler-runtime";
import useProducts from '@shared/utils/hooks/useProducts';
import { client } from '../../utils/trpc';
import { FoundersToken } from './FoundersToken';
import { ProductCard } from './ProductCard';

// The old `container` variant also declared `staggerChildren: 0.1`, but that
// was inert: ProductCard never declared matching `variants`, so there was
// nothing for the parent to stagger. Only the grid's own fade ever ran, and
// that's what `anim-enter` reproduces.

const PurchaseProducts = () => {
  const $ = _c(23);
  const {
    products
  } = useProducts(client);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== products) {
    const subscriptionProducts = products.filter(_temp).sort(_temp2);
    const tronProducts = products.filter(_temp3).sort(_temp4);
    t4 = "flex flex-col gap-8";
    let t6;
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div><h2 className="text-xl font-bold text-textPrimary">Premium Access</h2><p className="text-sm text-textSecondary">Higher hourly AI limits, exclusive spaces, and every tron you spend charged at our exact AI provider cost. Premium never changes what trons cost to buy — it changes what they buy, and only while it is active.</p></div>;
      t7 = <FoundersToken />;
      $[7] = t6;
      $[8] = t7;
    } else {
      t6 = $[7];
      t7 = $[8];
    }
    const t8 = subscriptionProducts.length > 0 && <div className="anim-enter grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">{subscriptionProducts.map(_temp5)}</div>;
    if ($[9] !== t8) {
      t5 = <section className="flex flex-col gap-4">{t6}{t7}{t8}</section>;
      $[9] = t8;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t2 = "flex flex-col gap-4";
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div><h2 className="text-xl font-bold text-textPrimary">Trons</h2><p className="text-sm text-textSecondary">Trons are AI credits, priced at what the AI costs us: one tron is one millionth of a dollar of provider cost, and $1 buys 1,000,000 of them — the same for everyone. Spend them on AI features or give them as awards on great posts (the trons transfer to the author). Premium members spend at exact cost; everyone else spends a small margin more. Pick whichever tier fits.</p></div>;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t0 = "anim-enter grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3";
    t1 = tronProducts.map(_temp6);
    $[0] = products;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[12] !== t0 || $[13] !== t1) {
    t6 = <div className={t0}>{t1}</div>;
    $[12] = t0;
    $[13] = t1;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t6) {
    t7 = <section className={t2}>{t3}{t6}</section>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t7) {
    t8 = <div className={t4}>{t5}{t7}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default PurchaseProducts;
function _temp(product) {
  return product.type === "MONTHLY_SUBSCRIPTION";
}
function _temp2(a, b) {
  return a.price - b.price;
}
function _temp3(product_0) {
  return product_0.type === "TRON";
}
function _temp4(a_0, b_0) {
  return b_0.price - a_0.price;
}
function _temp5(product_1) {
  return <ProductCard key={product_1.id} product={product_1} />;
}
function _temp6(product_2) {
  return <ProductCard key={product_2.id} product={product_2} />;
}